import { render, staticRenderFns } from "./Permission.tab.vue?vue&type=template&id=861089a2&scoped=true&"
import script from "./Permission.tab.vue?vue&type=script&lang=ts&"
export * from "./Permission.tab.vue?vue&type=script&lang=ts&"
import style0 from "./Permission.tab.vue?vue&type=style&index=0&id=861089a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861089a2",
  null
  
)

export default component.exports